var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiQuerySpaceAdmins } from '@/infrastructure/api-functions/api-query-space-admins.interface';
import { mobileNumberMasking } from '@cores/utils/getUserDisplayInfo';
let QuerySpaceAdminRepositoryImpl = class QuerySpaceAdminRepositoryImpl {
    constructor(_apiQuerySpaceAdmins) {
        this._apiQuerySpaceAdmins = _apiQuerySpaceAdmins;
    }
    async querySpaceAdmins(spaceId) {
        const resp = await this._apiQuerySpaceAdmins.querySpaceAdmins({ spaceId });
        const { records, selected } = resp;
        const selectedIds = selected.map((item) => item.user_id);
        const result = records.map((record) => {
            return {
                label: this._getAdminLabel(record),
                userId: record.user_id,
                selected: selectedIds.includes(record.user_id),
            };
        });
        return result;
    }
    _getAdminLabel(user) {
        return user.nickname || user.email || mobileNumberMasking(user.mobile_number || '');
    }
};
QuerySpaceAdminRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiQuerySpaceAdmins)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiQuerySpaceAdmins !== "undefined" && ApiQuerySpaceAdmins) === "function" ? _a : Object])
], QuerySpaceAdminRepositoryImpl);
export { QuerySpaceAdminRepositoryImpl };
